var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 7C18 9.20914 16.2091 11 14 11C11.7909 11 10 9.20914 10 7C10 4.79086 11.7909 3 14 3C16.2091 3 18 4.79086 18 7ZM21 7C21 10.866 17.866 14 14 14C10.134 14 7 10.866 7 7C7 3.13401 10.134 0 14 0C17.866 0 21 3.13401 21 7ZM3 23C3 22.5909 3.44054 21.3822 5.63912 20.0825C7.67505 18.879 10.6396 18 14 18C17.3604 18 20.3249 18.879 22.3609 20.0825C24.5595 21.3822 25 22.5909 25 23C25 24.1046 24.1046 25 23 25H5C3.89543 25 3 24.1046 3 23ZM14 15C6.3 15 0 19 0 23C0 25.7614 2.23858 28 5 28H23C25.7614 28 28 25.7614 28 23C28 19 21.7 15 14 15Z",
    fill: "#525252"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 7C18 9.20914 16.2091 11 14 11C11.7909 11 10 9.20914 10 7C10 4.79086 11.7909 3 14 3C16.2091 3 18 4.79086 18 7ZM21 7C21 10.866 17.866 14 14 14C10.134 14 7 10.866 7 7C7 3.13401 10.134 0 14 0C17.866 0 21 3.13401 21 7ZM3 23C3 22.5909 3.44054 21.3822 5.63912 20.0825C7.67505 18.879 10.6396 18 14 18C17.3604 18 20.3249 18.879 22.3609 20.0825C24.5595 21.3822 25 22.5909 25 23C25 24.1046 24.1046 25 23 25H5C3.89543 25 3 24.1046 3 23ZM14 15C6.3 15 0 19 0 23C0 25.7614 2.23858 28 5 28H23C25.7614 28 28 25.7614 28 23C28 19 21.7 15 14 15Z",
    fill: "#2563EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.0c4940b937ff43ba79f81d419bd50d06.svg";
export { ForwardRef as ReactComponent };